<template>
  <div class="WTopBar" :class="{ active: showMenuButton }">
    <button v-if="showMenuButton" class="menu-button" @click="$emit('click-menu')">
      <slot name="menu-icon">
        <iconify-icon icon="gg:menu" class="neutral-black" />
      </slot>
    </button>

    <div class="left" v-if="hasLeft">
      <slot name="left"></slot>
    </div>

    <div class="title-section">
      <!-- override entire title section -->
      <slot name="title">
        <w-title :size="3" v-if="title" class="topbar-title semi-bold">
          {{ title }}
        </w-title>
      </slot>
    </div>

    <div class="right" v-if="hasRight">
      <slot name="right"></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'WTopBar',
    emits: ['click-menu'],
    data() {
      return {};
    },
    props: {
      showMenuButton: {
        type: Boolean,
        default: true,
      },
      title: {
        type: String,
        required: false,
      },
    },
    computed: {
      hasLeft() {
        return !!this.$slots.left;
      },
      hasRight() {
        return !!this.$slots.right;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/styles/variables';
  @import '@/assets/styles/mixins';

  .WTopBar {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 2rem;

    padding: 0.875rem 2.5rem;
    background-color: $white;

    .menu-button {
      // icon buttons should have large touch radius
      height: 2rem;
      aspect-ratio: 1;
      border-radius: 100%;
      transition: all ease 0.4s;
      font-size: 1.5rem;
      display: none;

      &:hover {
        background-color: $bg-light;
      }
    }

    .title-section {
      flex: 1;
    }

    .left,
    .right {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 1rem;
    }
  }

  @include mobile {
    .WTopBar {
      padding: 1rem 1.5rem;
      gap: 1rem;
      border-bottom: 1px solid $input-border;

      .menu-button {
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .topbar-title {
        font-size: 1rem;
      }
    }
  }
</style>
